<ui-page-container>
  <mat-card class="media-page-content">
    <mat-card-title>{{ 'Media' | translate }}</mat-card-title>
    <mat-card-content>
      <ui-table
        [rowSelection]="'checkbox'"
        [fields]="fields"
        [pager]="pager$"
        [reload]="reload$"
        [filters]="filters$ | async"
        [itemsPage]="(page$ | async)?.current"
        [itemsPerPage]="(page$ | async)?.limit"
        [contextMenuActions]="mediaContextMenus"
        (itemsPageChange)="applyChangePageHandler($event)"
        (select)="selectHandler($event)"
        (rowAction)="manageRowActions($event)">
        <div tableActions>
          <app-entity-actions
            className="File"
            [selectedItemsCount]="selectedItems?.length"
            [config]="{ showAddToCollection: false, showExport: false }"
            (add)="addHandler()"
            (delete)="deleteSelectedHandler()">
          </app-entity-actions>
        </div>
        <div tableFilters>
          <ui-filters
            [dialogFilters]="MobileFiltersComponent"
            (action)="applyFilterWithDelayHandler($event)">
            <app-media-filters
              [filters]="filtersObj$ | async"
              #desktopFilter>
            </app-media-filters>
          </ui-filters>
        </div>
      </ui-table>
    </mat-card-content>
  </mat-card>
</ui-page-container>
